import { SidebarConfigProps } from './types';

export const sidebarConfig: SidebarConfigProps = {
  hiddenLabel: false,
  iconSize: 24,
  itemGap: 4,
  itemPadding: '4px 8px 4px 12px',
  itemRadius: 8,
  itemRootHeight: 44,
  itemSubHeight: 36,
};

export const SIDEBAR_WIDTH = 230;

export default sidebarConfig;
